export const activeArchivedTabs = ["Active", "Archived"] as const;

export type ActiveArchivedTab = (typeof activeArchivedTabs)[number];
